import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

const CompatibilityRedirect = ({ to }) => {
  const location = useLocation();

  return <Navigate to={{ pathname: to, search: location.search }} relative="path" replace />;
};

CompatibilityRedirect.propTypes = {
  to: PropTypes.string.isRequired
};

export default CompatibilityRedirect;
